{
  "labels": {
    "paste": "Beillesztés",
    "pasteAsPlaintext": "Beillesztés formázatlan szövegként",
    "pasteCharts": "Grafikon beillesztése",
    "selectAll": "Összes kijelölése",
    "multiSelect": "Elem hozzáadása a kijelöléshez",
    "moveCanvas": "Vászon mozgatása",
    "cut": "Kivágás",
    "copy": "Másolás",
    "copyAsPng": "Vágólapra másolás mint PNG",
    "copyAsSvg": "Vágólapra másolás mint SVG",
    "copyText": "Vágólapra másolás szövegként",
    "copySource": "Forrás másolása a vágólapra",
    "convertToCode": "Kód generálás",
    "bringForward": "Előrébb hozás",
    "sendToBack": "Hátraküldés",
    "bringToFront": "Előrehozás",
    "sendBackward": "Hátrébb küldés",
    "delete": "Törlés",
    "copyStyles": "Stílus másolása",
    "pasteStyles": "Stílus beillesztése",
    "stroke": "Körvonal",
    "changeStroke": "Vonal szín megváltoztatása",
    "background": "Háttér",
    "changeBackground": "Háttérszín megváltoztatása",
    "fill": "Kitöltés",
    "strokeWidth": "Körvonal vastagsága",
    "strokeStyle": "Körvonal stílusa",
    "strokeStyle_solid": "Kitöltött",
    "strokeStyle_dashed": "Szaggatott",
    "strokeStyle_dotted": "Pontozott",
    "sloppiness": "Stílus",
    "opacity": "Áttetszőség",
    "textAlign": "Szöveg igazítása",
    "edges": "Szélek",
    "sharp": "Éles",
    "round": "Kerek",
    "arrowheads": "Nyílhegyek",
    "arrowhead_none": "Nincs",
    "arrowhead_arrow": "Nyíl",
    "arrowhead_bar": "Oszlop",
    "arrowhead_circle": "Kör",
    "arrowhead_circle_outline": "Kör (Körvonal)",
    "arrowhead_triangle": "Háromszög",
    "arrowhead_triangle_outline": "Háromszög (Körvonal)",
    "arrowhead_diamond": "Rombusz",
    "arrowhead_diamond_outline": "Rombusz (Körvonal)",
    "arrowhead_crowfoot_many": "",
    "arrowhead_crowfoot_one": "",
    "arrowhead_crowfoot_one_or_many": "",
    "more_options": "",
    "arrowtypes": "Nyíl típus",
    "arrowtype_sharp": "Hegyes nyíl",
    "arrowtype_round": "Ívelt nyíl",
    "arrowtype_elbowed": "",
    "fontSize": "Betűméret",
    "fontFamily": "Betűkészlet család",
    "addWatermark": "Add hozzá, hogy \"Excalidraw-val készült\"",
    "handDrawn": "Kézzel rajzolt",
    "normal": "Normál",
    "code": "Kód",
    "small": "Kicsi",
    "medium": "Közepes",
    "large": "Nagy",
    "veryLarge": "Nagyon nagy",
    "solid": "Kitöltött",
    "hachure": "Vonalkázott",
    "zigzag": "Cikkcakk",
    "crossHatch": "Keresztcsíkozott",
    "thin": "Vékony",
    "bold": "Félkövér",
    "left": "Bal",
    "center": "Közép",
    "right": "Jobb",
    "extraBold": "Extra Félkövér",
    "architect": "Tervezői",
    "artist": "Művészi",
    "cartoonist": "Karikatúrás",
    "fileTitle": "Fájlnév",
    "colorPicker": "Színválasztó",
    "canvasColors": "Rajzvászonon használt",
    "canvasBackground": "Vászon háttérszíne",
    "drawingCanvas": "Rajzvászon",
    "clearCanvas": "Rajzfelület törlése",
    "layers": "Rétegek",
    "actions": "Műveletek",
    "language": "Nyelv",
    "liveCollaboration": "Élő együttműködés...",
    "duplicateSelection": "Duplikálás",
    "untitled": "Névtelen",
    "name": "Név",
    "yourName": "Neved",
    "madeWithExcalidraw": "Excalidraw-val készült",
    "group": "Csoportosítás",
    "ungroup": "Csoportbontás",
    "collaborators": "Közreműködők",
    "toggleGrid": "Keresés törlése",
    "addToLibrary": "Hozzáadás a könyvtárhoz",
    "removeFromLibrary": "Eltávólítás a könyvtárból",
    "libraryLoadingMessage": "Könyvtár betöltése…",
    "libraries": "Könyvtárak böngészése",
    "loadingScene": "Jelenet betöltése…",
    "loadScene": "Betöltés fájlból",
    "align": "Igazítás",
    "alignTop": "Felülre igazítás",
    "alignBottom": "Alulra igazítás",
    "alignLeft": "Balra igazítás",
    "alignRight": "Jobbra igazítás",
    "centerVertically": "Függőlegesen középre igazított",
    "centerHorizontally": "Vízszintesen középre igazított",
    "distributeHorizontally": "Vízszintes elosztás",
    "distributeVertically": "Függőleges elosztás",
    "flipHorizontal": "Vízszintes tükrözés",
    "flipVertical": "Függőleges tükrözés",
    "viewMode": "Nézet",
    "share": "Megosztás",
    "showStroke": "Körvonal színválasztó megjelenítése",
    "showBackground": "Háttérszín-választó megjelenítése",
    "showFonts": "",
    "toggleTheme": "Világos/sötét háttér kapcsoló",
    "theme": "Téma",
    "personalLib": "Személyes könyvtár",
    "excalidrawLib": "Excalidraw könyvtár",
    "decreaseFontSize": "Betűméret csökkentése",
    "increaseFontSize": "Betűméret növelése",
    "unbindText": "Szövegkötés feloldása",
    "bindText": "",
    "createContainerFromText": "Szöveg bekeretezése",
    "link": {
      "edit": "Hivatkozás szerkesztése",
      "editEmbed": "",
      "create": "Hivatkozás hozzáadása",
      "label": "Hivatkozás",
      "labelEmbed": "",
      "empty": "",
      "hint": "",
      "goToElement": ""
    },
    "lineEditor": {
      "edit": "",
      "editArrow": ""
    },
    "polygon": {
      "breakPolygon": "",
      "convertToPolygon": ""
    },
    "elementLock": {
      "lock": "",
      "unlock": "Zárolás feloldása",
      "lockAll": "Összes zárolása",
      "unlockAll": "Összes feloldása"
    },
    "statusPublished": "Közzétéve",
    "sidebarLock": "Oldalsó sáv nyitva tartása",
    "selectAllElementsInFrame": "",
    "removeAllElementsFromFrame": "",
    "eyeDropper": "",
    "textToDiagram": "Szövegből diagram",
    "prompt": "Egyéb",
    "followUs": "Kövess minket",
    "discordChat": "Discord chat",
    "zoomToFitViewport": "",
    "zoomToFitSelection": "Nagyítás a kijelölés méretére",
    "zoomToFit": "Az összes elem látótérbe hozása",
    "installPWA": "",
    "autoResize": "",
    "imageCropping": "",
    "unCroppedDimension": "",
    "copyElementLink": "",
    "linkToElement": "Hivatkozás az objektumhoz",
    "wrapSelectionInFrame": "",
    "tab": "Tab",
    "shapeSwitch": ""
  },
  "elementLink": {
    "title": "Hivatkozás az objektumhoz",
    "desc": "",
    "notFound": ""
  },
  "library": {
    "noItems": "",
    "hint_emptyLibrary": "",
    "hint_emptyPrivateLibrary": "",
    "search": {
      "inputPlaceholder": "Keresés a könyvtárban",
      "heading": "",
      "noResults": "",
      "clearSearch": "Keresés törlése"
    }
  },
  "search": {
    "title": "Rajzvászonon használt",
    "noMatch": "",
    "singleResult": "",
    "multipleResults": "",
    "placeholder": "",
    "frames": "Keretek",
    "texts": "Szövegek"
  },
  "buttons": {
    "clearReset": "Vászon törlése",
    "exportJSON": "Exportálás fájlba",
    "exportImage": "Kép exportálása...",
    "export": "Mentés másként...",
    "copyToClipboard": "Vágólapra másolás",
    "copyLink": "Link másolása",
    "save": "Mentés az aktuális fájlba",
    "saveAs": "Mentés másként",
    "load": "Megnyitás",
    "getShareableLink": "Megosztható link létrehozása",
    "close": "Bezárás",
    "selectLanguage": "Nyelv kiválasztása",
    "scrollBackToContent": "Visszagörgetés a tartalomhoz",
    "zoomIn": "Nagyítás",
    "zoomOut": "Kicsinyítés",
    "resetZoom": "Nagyítás alaphelyzetbe",
    "menu": "Menü",
    "done": "Kész",
    "edit": "Szerkesztés",
    "undo": "Vissza",
    "redo": "Újra",
    "resetLibrary": "Könyvtár alaphelyzetbe állítása",
    "createNewRoom": "Új szoba létrehozása",
    "fullScreen": "Teljes képernyő",
    "darkMode": "Sötét mód",
    "lightMode": "Világos mód",
    "systemMode": "Rendszer mód",
    "zenMode": "Letisztult mód",
    "objectsSnapMode": "Objektumhoz illeszt",
    "exitZenMode": "Kilépés a letisztult módból",
    "cancel": "Mégsem",
    "saveLibNames": "",
    "clear": "Kiűrítés",
    "remove": "Eltávolítás",
    "embed": "Beágyazás be/ki",
    "publishLibrary": "",
    "submit": "Elküldés",
    "confirm": "Megerősítés",
    "embeddableInteractionButton": "Interakció Kattintással"
  },
  "alerts": {
    "clearReset": "Ez a művelet törli a vászont. Biztos benne?",
    "couldNotCreateShareableLink": "Nem sikerült megosztható linket létrehozni.",
    "couldNotCreateShareableLinkTooBig": "Nem sikerült megosztható linket látrehozni: túl nagy a jelenet",
    "couldNotLoadInvalidFile": "Nem sikerült betölteni a helytelen fájlt",
    "importBackendFailed": "Nem sikerült betölteni a szerverről.",
    "cannotExportEmptyCanvas": "Üres vászont nem lehet exportálni.",
    "couldNotCopyToClipboard": "Nem lehet a vágólapra másolni.",
    "decryptFailed": "Nem sikerült visszafejteni a titkosított adatot.",
    "uploadedSecurly": "A feltöltést végpontok közötti titkosítással biztosítottuk, ami azt jelenti, hogy egy harmadik fél nem tudja megnézni a tartalmát, beleértve az Excalidraw szervereit is.",
    "loadSceneOverridePrompt": "A betöltött külső rajz felül fogja írnia meglévőt. Szeretnéd folytatni?",
    "collabStopOverridePrompt": "A munkamenet leállítása felül fogja írni az előzőleg helyben tárolt rajzot. Biztosan ezt akarod?\n(Ha meg akarod tartani a helyben tárolt rajzot, egyszerűen csak zárd be a böngésző fület)",
    "errorAddingToLibrary": "A tétel nem addható hozzá a könyvtárhoz",
    "errorRemovingFromLibrary": "A tétel nem távolítható el a könyvtárból",
    "confirmAddLibrary": "Ez a művelet {{numShapes}} formát fog hozzáadni a könyvtáradhoz. Biztos vagy benne?",
    "imageDoesNotContainScene": "Úgy tűnik, hogy ez a kép nem tartalmaz jelenetadatokat. Engedélyezted a jelenetbeágyazást az exportálás során?",
    "cannotRestoreFromImage": "A jelenet visszaállítása nem sikerült ebből a kép fájlból",
    "invalidSceneUrl": "Nem sikerült importálni a jelenetet a megadott URL-ről. Rossz formátumú, vagy nem tartalmaz érvényes Excalidraw JSON-adatokat.",
    "resetLibrary": "Ezzel törlöd a könyvtárát. biztos vagy ebben?",
    "removeItemsFromsLibrary": "{{count}} elemet törölsz a könyvtárból?",
    "invalidEncryptionKey": "A titkosítási kulcsnak 22 karakterből kell állnia. Az élő együttműködés le van tiltva.",
    "collabOfflineWarning": "",
    "localStorageQuotaExceeded": ""
  },
  "errors": {
    "unsupportedFileType": "Nem támogatott fájltípus.",
    "imageInsertError": "Nem sikerült beszúrni a képet. Próbáld újra később...",
    "fileTooBig": "A fájl túl nagy. A megengedett maximális méret {{maxSize}}.",
    "svgImageInsertError": "Nem sikerült beszúrni az SVG-képet. Az SVG szintaktika érvénytelennek tűnik.",
    "failedToFetchImage": "",
    "cannotResolveCollabServer": "",
    "importLibraryError": "",
    "saveLibraryError": "",
    "collabSaveFailed": "",
    "collabSaveFailed_sizeExceeded": "",
    "imageToolNotSupported": "",
    "brave_measure_text_error": {
      "line1": "",
      "line2": "",
      "line3": "",
      "line4": ""
    },
    "libraryElementTypeError": {
      "embeddable": "",
      "iframe": "",
      "image": ""
    },
    "asyncPasteFailedOnRead": "",
    "asyncPasteFailedOnParse": "",
    "copyToSystemClipboardFailed": ""
  },
  "toolBar": {
    "selection": "Kijelölés",
    "lasso": "",
    "image": "Kép beszúrása",
    "rectangle": "Téglalap",
    "diamond": "Rombusz",
    "ellipse": "Ellipszis",
    "arrow": "Nyíl",
    "line": "Vonal",
    "freedraw": "Rajzolás",
    "text": "Szöveg",
    "library": "Könyvtár",
    "lock": "Rajzolás után az aktív eszközt tartsa kijelölve",
    "penMode": "",
    "link": "Hivatkozás hozzáadása/frissítése a kiválasztott alakzathoz",
    "eraser": "Radír",
    "frame": "",
    "magicframe": "",
    "embeddable": "",
    "laser": "Lézermutató",
    "hand": "",
    "extraTools": "További eszközök",
    "mermaidToExcalidraw": "",
    "convertElementType": ""
  },
  "element": {
    "rectangle": "Téglalap",
    "diamond": "Rombusz",
    "ellipse": "Ellipszis",
    "arrow": "Nyíl",
    "line": "Vonal",
    "freedraw": "",
    "text": "Szöveg",
    "image": "Kép",
    "group": "Csoport",
    "frame": "Keret",
    "magicframe": "",
    "embeddable": "Weblap beágyazása",
    "selection": "Kijelölés",
    "iframe": ""
  },
  "headings": {
    "canvasActions": "Vászon műveletek",
    "selectedShapeActions": "Kijelölt forma műveletei",
    "shapes": "Alakzatok"
  },
  "hints": {
    "dismissSearch": "",
    "canvasPanning": "A vászon mozgatásához tartsd lenyomva a {{shortcut_1}} vagy {{shortcut_2}} billentyűt húzás közben, vagy használd a kéz eszközt",
    "linearElement": "Kattintással görbe, az eger húzásával pedig egyenes nyilat rajzolhatsz",
    "arrowTool": "",
    "arrowBindModifiers": "",
    "freeDraw": "Kattints és húzd, majd engedd el, amikor végeztél",
    "text": "Tipp: A kijelölés eszközzel a dupla kattintás új szöveget hoz létre",
    "embeddable": "",
    "text_selected": "",
    "text_editing": "",
    "linearElementMulti": "",
    "lockAngle": "",
    "resize": "",
    "resizeImage": "",
    "rotate": "",
    "lineEditor_info": "",
    "lineEditor_line_info": "",
    "lineEditor_pointSelected": "",
    "lineEditor_nothingSelected": "",
    "publishLibrary": "Tedd közzé saját könyvtáradat",
    "bindTextToElement": "",
    "createFlowchart": "",
    "deepBoxSelect": "",
    "eraserRevert": "",
    "firefox_clipboard_write": "",
    "disableSnapping": "",
    "enterCropEditor": "",
    "leaveCropEditor": ""
  },
  "canvasError": {
    "cannotShowPreview": "Előnézet nem jeleníthető meg",
    "canvasTooBig": "A vászon talán túl nagy.",
    "canvasTooBigTip": "Tipp: próbáld meg a legtávolabbi elemeket közelebb hozni egy máshoz."
  },
  "errorSplash": {
    "headingMain": "Hiba történt. Próbáld <button>újratölteni az oldalt.</button>",
    "clearCanvasMessage": "Ha az újratöltés nem működik, próbáld <button>letörölni a vászont.</button>",
    "clearCanvasCaveat": " Ezzel az eddigi munka elveszik ",
    "trackedToSentry": "A hibakód azonosítóval {{eventId}} nyomon van követve a rendszerünkben.",
    "openIssueMessage": "Vigyáztunk arra, hogy a jelenthez tartozó információ ne jelenjen meg a hibaüzenetben. Ha a jeleneted nem bizalmas, kérjük add hozzá a <button>hibakövető rendszerünkhöz.</button> Kérjük, másolja be az alábbi információkat a GitHub problémába.",
    "sceneContent": "Jelenet tartalma:"
  },
  "shareDialog": {
    "or": "Vagy"
  },
  "roomDialog": {
    "desc_intro": "",
    "desc_privacy": "",
    "button_startSession": "Munkamenet indítása",
    "button_stopSession": "Munkamenet leállítása",
    "desc_inProgressIntro": "Az élő együttműködési munkamenet folyamatban van.",
    "desc_shareLink": "Ossza meg ezt a linket bárkivel, akivel együtt szeretne működni:",
    "desc_exitSession": "Az munkamenet leállítása kilépteti önt a szobából, de folytathatja a munkát a saját gépén. Vegye figyelembe, hogy ez nem érinti más emberek munkáját és ők továbbra is együttműködhetnek a saját változatukon.",
    "shareTitle": "Csatlakozás egy élő együttműködési munkamenethez az Excalidraw-ban"
  },
  "errorDialog": {
    "title": "Hiba"
  },
  "exportDialog": {
    "disk_title": "Mentés lemezre",
    "disk_details": "Exportálja a jelenetadatokat egy fájlba, amelyből később importálhatja.",
    "disk_button": "Mentés fájlba",
    "link_title": "Megosztható hivatkozás",
    "link_details": "Exportálás csak olvasható hivatkozásként.",
    "link_button": "Exportálás hivatkozásba",
    "excalidrawplus_description": "Mentse el a jelenetet az Excalidraw+ munkaterületére.",
    "excalidrawplus_button": "Exportálás",
    "excalidrawplus_exportError": "Jelenleg nem lehet exportálni az Excalidraw+-ba..."
  },
  "helpDialog": {
    "blog": "Olvasd a blogunkat",
    "click": "kattintás",
    "deepSelect": "Mély kijelölés",
    "deepBoxSelect": "Mély kijelölés a dobozon belül, és a húzás megakadályozása",
    "createFlowchart": "",
    "navigateFlowchart": "",
    "curvedArrow": "Ívelt nyíl",
    "curvedLine": "Ívelt vonal",
    "documentation": "Dokumentáció",
    "doubleClick": "dupla kattintás",
    "drag": "vonszolás",
    "editor": "Szerkesztő",
    "editLineArrowPoints": "",
    "editText": "Szöveg szerkesztése / címke hozzáadása",
    "github": "Hibát találtál? Küld be",
    "howto": "Kövesd az útmutatóinkat",
    "or": "vagy",
    "preventBinding": "A nyíl ne ragadjon",
    "tools": "",
    "shortcuts": "Gyorsbillentyűk",
    "textFinish": "Szerkesztés befejezése (szöveg)",
    "textNewLine": "Új sor hozzáadása (szöveg)",
    "title": "Segítség",
    "view": "Nézet",
    "zoomToFit": "Az összes elem látótérbe hozása",
    "zoomToSelection": "Kijelölésre nagyítás",
    "toggleElementLock": "",
    "movePageUpDown": "",
    "movePageLeftRight": "",
    "cropStart": "Kép kivágása",
    "cropFinish": ""
  },
  "clearCanvasDialog": {
    "title": "Rajzvászon alaphelyzetbe"
  },
  "publishDialog": {
    "title": "Könyvtár közzététele",
    "itemName": "Tétel neve",
    "authorName": "Szerző neve",
    "githubUsername": "GitHub felhasználónév",
    "twitterUsername": "Twitter felhasználónév",
    "libraryName": "Könyvtár neve",
    "libraryDesc": "Könyvtár leírása",
    "website": "Weboldal",
    "placeholder": {
      "authorName": "Neved vagy felhasználóneved",
      "libraryName": "A könyvtárad neve",
      "libraryDesc": "A könyvtárad használatát segítő leírás",
      "githubHandle": "GitHub-handle(opcionális), így szerkesztheted a könyvtárat, miután elküldted ellenőrzésre",
      "twitterHandle": "Twitter-felhasználónév (opcionális), így tudjuk, kinek kell jóváírni a Twitteren keresztüli reklámozást",
      "website": "Hivatkozás személyes webhelyedre vagy máshová (nem kötelező)"
    },
    "errors": {
      "required": "Kötelező",
      "website": "Adj meg egy érvényes URL-t"
    },
    "noteDescription": "Küld be könyvtáradat, hogy bekerüljön a <link>nyilvános könyvtár tárolóba</link>hogy mások is felhasználhassák a rajzaikban.",
    "noteGuidelines": "A könyvtárat először manuálisan kell jóváhagyni. Kérjük, olvassa el a <link>segédletet</link> benyújtása előtt. Szüksége lesz egy GitHub-fiókra a kommunikációhoz és a módosításokhoz, ha kérik, de ez nem feltétlenül szükséges.",
    "noteLicense": "A beküldéssel elfogadja, hogy a könyvtár a következő alatt kerül közzétételre <link>MIT Licensz </link>ami röviden azt jelenti, hogy bárki korlátozás nélkül használhatja őket.",
    "noteItems": "Minden könyvtárelemnek saját nevével kell rendelkeznie, hogy szűrhető legyen. A következő könyvtári tételek kerülnek bele:",
    "atleastOneLibItem": "A kezdéshez válassz ki legalább egy könyvtári elemet",
    "republishWarning": ""
  },
  "publishSuccessDialog": {
    "title": "A könyvtár beküldve",
    "content": "Köszönjük {{authorName}}. Könyvtáradat elküldtük felülvizsgálatra. Nyomon követheted az állapotot<link>itt</link>"
  },
  "confirmDialog": {
    "resetLibrary": "Könyvtár alaphelyzetbe állítása",
    "removeItemsFromLib": "A kiválasztott elemek eltávolítása a könyvtárból"
  },
  "imageExportDialog": {
    "header": "Kép exportálása",
    "label": {
      "withBackground": "Háttér",
      "onlySelected": "Csak a kijelölt",
      "darkMode": "Sötét mód",
      "embedScene": "Jelenet beágyazása",
      "scale": "Nagyítás",
      "padding": "Eltartás"
    },
    "tooltip": {
      "embedScene": "A jelenetet leíró adatok hozzá lesznek adva a PNG/SVG fájlhoz, így a jelenetet vissza lehet majd tölteni belőle. Ez megnöveli a fájl méretét."
    },
    "title": {
      "exportToPng": "Exportálás PNG-be",
      "exportToSvg": "Exportálás SVG-be",
      "copyPngToClipboard": "PNG másolása a vágólapra"
    },
    "button": {
      "exportToPng": "PNG",
      "exportToSvg": "SVG",
      "copyPngToClipboard": "Vágólapra másolás"
    }
  },
  "encrypted": {
    "tooltip": "A rajzaidat végpontok közötti titkosítással tároljuk, tehát az Excalidraw szervereiről se tud más belenézni.",
    "link": "Blogbejegyzés a végpontok közötti titkosításról az Excalidraw-ban"
  },
  "stats": {
    "angle": "Szög",
    "shapes": "Alakzatok",
    "height": "Magasság",
    "scene": "Jelenet",
    "selected": "Kijelölt",
    "storage": "Tárhely",
    "fullTitle": "",
    "title": "Tulajdonságok",
    "generalStats": "Általános",
    "elementProperties": "",
    "total": "Összesen",
    "version": "Verzió",
    "versionCopy": "Kattints a másoláshoz",
    "versionNotAvailable": "A verzió nem elérhető",
    "width": "Szélesség"
  },
  "toast": {
    "addedToLibrary": "Könyvtárhoz adva",
    "copyStyles": "Másolt stílusok.",
    "copyToClipboard": "Vágólapra másolva.",
    "copyToClipboardAsPng": "Az {{exportSelection}} PNG formátumban a vágólapra másolva \n({{exportColorScheme}})",
    "copyToClipboardAsSvg": "",
    "fileSaved": "Fájl elmentve.",
    "fileSavedToFilename": "Mentve mint {filename}",
    "canvas": "rajzvászon",
    "selection": "kijelölés",
    "pasteAsSingleElement": "",
    "unableToEmbed": "",
    "unrecognizedLinkFormat": "",
    "elementLinkCopied": ""
  },
  "colors": {
    "transparent": "Átlátszó",
    "black": "Fekete",
    "white": "Fehér",
    "red": "Piros",
    "pink": "Pink",
    "grape": "Szőlő",
    "violet": "Lila",
    "gray": "Szürke",
    "blue": "Kék",
    "cyan": "Cián",
    "teal": "Türkiz",
    "green": "Zöld",
    "yellow": "Sárga",
    "orange": "Narancssárga",
    "bronze": "Bronz"
  },
  "welcomeScreen": {
    "app": {
      "center_heading": "",
      "center_heading_line2": "",
      "center_heading_line3": "",
      "center_heading_plus": "",
      "menuHint": ""
    },
    "defaults": {
      "menuHint": "",
      "center_heading": "",
      "toolbarHint": "",
      "helpHint": ""
    }
  },
  "colorPicker": {
    "color": "Szín",
    "mostUsedCustomColors": "",
    "colors": "",
    "shades": "",
    "hexCode": "",
    "noShades": ""
  },
  "overwriteConfirm": {
    "action": {
      "exportToImage": {
        "title": "",
        "button": "",
        "description": ""
      },
      "saveToDisk": {
        "title": "",
        "button": "",
        "description": ""
      },
      "excalidrawPlus": {
        "title": "",
        "button": "",
        "description": ""
      }
    },
    "modal": {
      "loadFromFile": {
        "title": "",
        "button": "",
        "description": ""
      },
      "shareableLink": {
        "title": "",
        "button": "",
        "description": ""
      }
    }
  },
  "mermaid": {
    "title": "",
    "button": "",
    "description": "",
    "syntax": "",
    "preview": "",
    "label": "",
    "inputPlaceholder": ""
  },
  "ttd": {
    "error": ""
  },
  "chat": {
    "inputPlaceholder": "",
    "inputPlaceholderWithMessages": "",
    "generating": "",
    "rateLimitRemaining": "",
    "role": {
      "user": "Te",
      "assistant": "AI asszisztens",
      "system": "Rendszer"
    },
    "aiBeta": "",
    "label": "Csevegés",
    "menu": "Menü",
    "newChat": "Új csevegés",
    "deleteChat": "Csevegés törlése",
    "deleteMessage": "Üzenet törlése",
    "viewAsMermaid": "",
    "placeholder": {
      "title": "",
      "description": "",
      "hint": ""
    },
    "preview": "Előnézet",
    "insert": "Beszúrás",
    "retry": "Újra",
    "errors": {
      "promptTooShort": "",
      "promptTooLong": "",
      "generationFailed": "",
      "invalidDiagram": "",
      "fixInMermaid": "",
      "aiRepair": "",
      "requestAborted": "",
      "requestFailed": "",
      "mermaidParseError": ""
    },
    "rateLimit": {
      "messageLimit": "",
      "generalRateLimit": "",
      "messageLimitInputPlaceholder": ""
    },
    "upsellBtnLabel": "Frissítés Plus csomagra"
  },
  "quickSearch": {
    "placeholder": "Gyorskeresés"
  },
  "fontList": {
    "badge": {
      "old": "régi"
    },
    "sceneFonts": "",
    "availableFonts": "Elérhető betűtípusok",
    "empty": "Nem találhatóak betűtípusok"
  },
  "userList": {
    "empty": "",
    "hint": {
      "text": "",
      "followStatus": "",
      "inCall": "",
      "micMuted": "",
      "isSpeaking": ""
    }
  },
  "commandPalette": {
    "title": "Parancspanel",
    "shortcuts": {
      "select": "Kiválasztás",
      "confirm": "Megerősítés",
      "close": "Bezárás"
    },
    "recents": "Legutóbb használt",
    "search": {
      "placeholder": "",
      "noMatch": ""
    },
    "itemNotAvailable": "",
    "shortcutHint": ""
  },
  "keys": {
    "ctrl": "Ctrl",
    "option": "Option",
    "cmd": "",
    "alt": "",
    "escape": "",
    "enter": "",
    "shift": "",
    "spacebar": "",
    "delete": "",
    "mmb": ""
  }
}
